

































































































































































































































































































































import { Component, Watch, Emit, Vue, Prop } from 'vue-property-decorator'
/* component */
import FieldChoiceModal from '@/app/components/Common/FieldChoiceModal.vue'
/* api */
import graphItemApi from '@/app/model/api/graphItemApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { plantingSeason, routerPath, fieldDetailsApiFlag, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    FieldChoiceModal
  }
})
export default class GraphSettingModal extends Vue {
  @Prop() private showCanonData!: boolean

  /* 表示 */
  private isActive:string = '1'
  private showComparisonData : boolean = false
  private showFieldChoice: boolean = false
  private notDataMessage: boolean = false
  /* データ */
  private stemNumberType: string = '0'
  private checkboxes: {[key: string]: string|boolean}[] = this.getcheckboxes()
  private masterList:{[key: string]: string|number}[] = []
  private yearList: number[] = []
  private defaultMasterData: any = ''
  private selectedMasterData: any = ''
  private selectedYear: number = 0
  private selectedSeason: string = ''
  private selectedPast: number = 0
  private selectedPastName: string = ''
  private selectedFieldName: string = ''
  private selectedFieldId: string = ''
  private pastData: any[] = []
  /* flag */
  private defaultDataChange: boolean = false

  /* 現在表示されているグラフの年とシーズンを表示 */
  private get defaultDisplayYear () {
    return this.$store.state.graphState.defaultGraphYear
  }
  private get defaultDisplaySeason () {
    return this.$store.state.graphState.defaultGraphSeason
  }
  private get masterDataFlag (): boolean {
    return this.$store.state.setFlagState.graphMasterDataFlag
  }
  private get changeGraphCheckbox (): boolean {
    return this.$store.state.graphState.graphCheckbox
  }
  @Watch('changeGraphCheckbox')
  chengeDisplayCheckcox (checkboxs: any) {
    for (let i in this.checkboxes) {
      for (let j in checkboxs) {
        if (this.checkboxes[i].value === checkboxs[j].value) {
          this.checkboxes[i].checked = checkboxs[j].checked
        }
      }
    }
  }
  @Watch('defaultDisplayYear')
  setDisplayYear (year: string) {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData === null) {
      this.selectedYear = parseInt(year)
    }
  }
  @Watch('defaultDisplaySeason')
  setDisplaySeason (season: string) {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (settingData === null) {
      this.selectedSeason = season
    }
  }
  @Watch('masterDataFlag')
  getMateData (flag: boolean) {
    if (flag) {
      this.displayCheckbox()
    }
  }
  @Watch('showCanonData')
  changeCanonData (flag: boolean) {
    this.checkboxes[7].display = flag
    this.checkboxes[8].display = flag
    this.checkboxes[9].display = flag
    this.checkboxes[10].display = flag
    this.checkboxes[11].display = flag
    this.checkboxes[12].display = flag
  }

  created () {
    let fieldId = this.$route.params.field_id
    let plantingId = this.$route.params.planting_id
    let settingData = JSON.parse(Local.getGraphSettingData(fieldId)!)

    /* 表示年度リストを作成 */
    const endYear = new Date().getFullYear() + 1
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }
    // グラフ表示項目設定の保持があれば項目に反映
    if (settingData !== null) {
      this.checkboxes = settingData.checkboxs
      this.selectedYear = settingData.year
      this.selectedSeason = settingData.season
      this.changeTab(settingData.tab)
      this.selectedFieldName = settingData.fieldName
      this.selectedPast = settingData.past

      if (settingData.tab === '3') {
        this.showFieldChoice = true
      }

      if (settingData.tab !== '1') {
        this.$store.commit('graphToggleState/setHiddenComparisonData', false)
      }
    }

    this.getGraphItem(fieldId, plantingId)
  }

  private displayCheckbox () {
    this.stemNumberType = Session.getStemNumberType()!
    if (this.stemNumberType === '1') {
      // （平米）非表示
      this.checkboxes[2].display = false
      this.checkboxes[2].checked = true
      // 改行用空コンテンツ追加
      this.checkboxes[6].display = true
    } else if (this.stemNumberType === '2') {
      // （株）非表示
      this.checkboxes[1].display = false
      this.checkboxes[1].checked = true
      // 改行用空コンテンツ追加
      this.checkboxes[6].display = true
    } else {
      // 改行用空コンテンツ非表示
      this.checkboxes[6].display = false
    }
  }

  /* モーダルデータ取得 */
  private getGraphItem (fieldId: string, plantingId: string) {
    (async () => {
      const result = await graphItemApi.getGraphItem(fieldId)

      if (result.isOk()) {
        this.pastData = result.getPayload().plant_data
        this.$emit('past-data', this.pastData)

        /* 現在のマスタデータ名を取得 */
        let varietyId = JSON.parse(Session.getVarietyId()!)
        for (var j in this.masterList) {
          if (this.masterList[j].id === varietyId) {
            this.selectedMasterData = this.masterList[j]
            this.defaultMasterData = this.masterList[j]
          }
        }

        if (this.pastData.length === 0) {
          this.notDataMessage = true
        } else {
          // flag
          this.$store.commit('setFlagState/setGraphChangeDisplayYear', true)

          /* 現在表示しているグラフの年とシーズンを保持 */
          this.$store.commit('graphState/setDefaultGraphYear', this.pastData[this.pastData.length - 1].year)
          this.$store.commit('graphState/setDefaultGraphSeason', this.pastData[this.pastData.length - 1].season)
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        this.$emit('close-modal')
      }
    })()
  }

  /* 作付けID取得 */
  private getPlantingId (accordionId: number, fieldId: number) {
    if (fieldId !== 0 && fieldId !== undefined) {
      let result: any[] = []

      if (Session.getFieldDetailsData(String(accordionId))! !== null) {
        /* storageから取得 */
        result = JSON.parse(Session.getFieldDetailsData(String(accordionId))!)

        // timestamp削除
        if (result !== null) {
          delete result[0]
        }
        for (var i in result) {
          if (result[i].field_id === fieldId) {
            return result[i].planting_id
          }
        }
      } else {
        /* APIから取得 */
        return this.getDetailsData(accordionId, fieldId)
      }
    }
  }

  /* Storageにデータがない場合APIから取得 */
  private getDetailsData (accordionId: number, fieldId: number) {
    (async () => {
      let searchItem = {
        refile: this.$store.state.fieldState.plantingOnly,
        stage: this.$store.state.fieldState.fieldSearchStatus,
        variety: this.$store.state.fieldState.fieldSearchVariety,
        risk: this.$store.state.fieldState.fieldSearchRisk,
        word: this.$store.state.fieldState.fieldSearchText
      }
      const result = await FieldDetailsApi.getFieldDetailsData(String(accordionId), true, fieldDetailsApiFlag.FLAG_FIELD, searchItem, [])

      if (result.isOk()) {
        let detailsList = result.getPayload().field_detail_list

        // timestamp削除
        if (detailsList !== null) {
          delete detailsList[0]
        }
        for (var i in result) {
          if (detailsList[i].field_id === fieldId) {
            return detailsList[i].planting_id
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  /* 選択した圃場名を表示 */
  private displaySelectedFiled (val: any) {
    this.selectedFieldName = val
    this.showFieldChoice = true
  }

  /* 選択した圃場ID取得 */
  private getSelectedFiledId (id: any) {
    this.selectedFieldId = id
  }

  /* 項目設定処理 */
  private setGraphItem () {
    let checkList = []
    for (var j in this.checkboxes) {
      if (this.checkboxes[j].value !== '' && this.checkboxes[j].checked) {
        checkList.push(this.checkboxes[j])
      }
    }

    if (checkList.length === 14 &&
        checkList[0].label === '積算温度' &&
        checkList[1].label === '茎数(株)' &&
        checkList[2].label === '茎数(平米)' &&
        checkList[3].label === '葉色値' &&
        checkList[4].label === '草丈' &&
        checkList[5].label === 'NDVI' &&
        checkList[6].label === '画像解析-茎数(株)' &&
        checkList[7].label === '画像解析-葉色' &&
        checkList[8].label === '画像解析-草丈' &&
        checkList[9].label === '桿長' &&
        checkList[10].label === '穂長' &&
        checkList[11].label === '水位' &&
        checkList[12].label === '水温' &&
        checkList[13].label === '地温' &&
        this.selectedYear === this.$store.state.graphState.defaultGraphYear &&
        this.selectedSeason === this.$store.state.graphState.defaultGraphSeason &&
        this.selectedFieldName === '' &&
        this.selectedPast === 0) {
      /* ローカルストレージから削除 */
      localStorage.removeItem('graphSetting' + this.$route.params.field_id)
    } else {
      let plantingId = 0
      for (var i in this.pastData) {
        if (this.pastData[i].season === this.selectedSeason) {
          if (this.pastData[i].year === this.selectedYear) {
            /* 表示年度とシーズン */
            let display = this.selectedYear + '年 ' + this.pastData[i].season
            plantingId = this.pastData[i].planting_id
          }
        }

        /* 過去データ名 */
        if (this.isActive === '2') {
          if (this.pastData[i].planting_id === this.selectedPast) {
            let year = this.pastData[i].year + '年'
            let season = this.pastData[i].season

            this.selectedPastName = year + ' ' + season
          }
        }
      }

      const data = {
        checkboxs: this.checkboxes,
        year: this.selectedYear,
        season: this.selectedSeason,
        plantingId: plantingId,
        fieldId: this.selectedFieldId,
        fieldName: this.selectedFieldName,
        past: this.selectedPast,
        pastName: this.selectedPastName,
        tab: this.isActive
      }
      /* ローカルストレージに保持 */
      Local.setGraphSettingData(JSON.stringify(data), this.$route.params.field_id)
    }

    /* 表示項目 */
    this.changeDisplayItem(this.checkboxes)
    this.$store.commit('graphToggleState/setCheckboxes', this.checkboxes)

    if (this.defaultDataChange) {
      this.changeDisplayYear(this.selectedYear, this.selectedSeason)
      this.defaultDataChange = false

      if (this.selectedFieldName !== '') {
        this.comparisonField(String(this.$store.state.fieldChoiceState.modalPlantingId))
      }

      if (this.selectedPast !== 0) {
        this.comparisonField(String(this.selectedPast))
      }

      this.$emit('display-graph-item', {
        checkbox: checkList,
        year: this.selectedYear,
        season: this.selectedSeason,
        field: this.selectedFieldName,
        past: this.selectedPastName
      })
    }

    /* 比較データありなし */
    if (this.selectedFieldName === '' && this.selectedPast === 0) {
      // どちらも選択されていない＝比較無
      this.$store.commit('graphToggleState/setHiddenComparisonData', true)
    } else {
      // それ以外＝比較有り
      this.$store.commit('graphToggleState/setHiddenComparisonData', false)
    }

    /* 比較(圃場) */
    if (this.selectedFieldName !== '') {
      this.comparisonField(String(this.$store.state.fieldChoiceState.modalPlantingId))
    } else {
      this.selectedFieldName = ''
      this.$store.commit('graphToggleState/setChangeComparisonGraph', true)
    }

    /* 比較(過去) */
    if (this.selectedPast !== 0) {
      this.comparisonField(String(this.selectedPast))
    } else {
      this.selectedPast = 0
      this.selectedPastName = ''
      this.$store.commit('graphToggleState/setChangeComparisonGraph', true)
    }

    this.$emit('display-graph-item', {
      checkbox: checkList,
      year: this.selectedYear,
      season: this.selectedSeason,
      field: this.selectedFieldName,
      past: this.selectedPastName
    })

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
    this.$emit('tab-reset')
  }

  /* 表示年変更 */
  private changeDisplayYear (year: number, season: string) {
    for (var i in this.pastData) {
      if (this.pastData[i].season === season) {
        if (this.pastData[i].year === year) {
          /* 表示年度とシーズン */
          let display = year + '年 ' + this.pastData[i].season
          this.$store.commit('fieldDetailsState/setDisplayYear', display)

          this.$emit('change-display-year', this.pastData[i].planting_id)
        }
      }
    }

    let pastList = this.pastData.filter(function (data) {
      return (data.season === season && data.year === year)
    })
    // データがなかった場合
    if (pastList.length === 0) {
      this.$emit('show-season-error')

      // 表示を元に戻す
      this.selectedYear = this.$store.state.graphState.defaultGraphYear
      this.selectedSeason = this.$store.state.graphState.defaultGraphSeason
    }

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
  }

  /* 表示項目変更 */
  private changeDisplayItem (list: any) {
    /* 選択されたチェックボックス */
    let checkList = []
    for (var i in this.checkboxes) {
      if (this.checkboxes[i].checked) {
        checkList.push(this.checkboxes[i])
      }
    }
    this.$emit('update-checkboxes', list)
  }

  /* 他の圃場比較 */
  private comparisonField (id: string) {
    this.$emit('add-comparison-data', { id: id, type: 'plant' })
    this.$emit('add-comparison-stage', { id: id, type: 'master' })

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
  }

  /* タブの切り替え */
  private changeTab (num: string) {
    this.isActive = num
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)

    /* 選択中のものをリセット */
    this.selectedFieldName = ''
    this.selectedPast = 0
    this.showFieldChoice = false
    this.$store.commit('fieldChoiceState/setChoosingModalFieldId', null)

    if (num === '3') {
      this.showComparisonData = false
      this.showFieldChoice = true
      if (settingData !== null) {
        this.selectedFieldName = settingData.fieldName
      }
    } else {
      this.showComparisonData = true
    }
  }

  /* 表示年・シーズンの変更検知 */
  private defaultChange () {
    this.defaultDataChange = true
  }

  private getcheckboxes () {
    return [
      // メイングラフ
      { label: '積算温度', value: 'integrationTemperature', checked: true, display: true },
      { label: '茎数(株)', value: 'stemNumber', checked: true, display: true },
      { label: '茎数(平米)', value: 'stemNumberM2', checked: true, display: true },
      { label: '葉色値', value: 'spad', checked: true, display: true },
      { label: '草丈', value: 'growthHeight', checked: true, display: true },
      { label: 'NDVI', value: 'leafAge', checked: true, display: true },
      { label: '', value: '', checked: false, display: false },
      // 画像解析
      { label: '画像解析-茎数(株)', value: 'imageAnalysisStemNumber', checked: true, display: this.showCanonData },
      { label: '画像解析-葉色', value: 'imageAnalysisSpad', checked: true, display: this.showCanonData },
      { label: '画像解析-草丈', value: 'imageAnalysisGrowthHeight', checked: true, display: this.showCanonData },
      { label: '', value: '', checked: false, display: this.showCanonData },
      { label: '', value: '', checked: false, display: this.showCanonData },
      { label: '', value: '', checked: false, display: this.showCanonData },
      // 穂長、穂長
      { label: '桿長', value: 'stemLength', checked: true, display: true },
      { label: '穂長', value: 'earLength', checked: true, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      // 気温
      { label: '日平均気温', value: 'temperature', checked: false, display: true },
      { label: '最高気温', value: 'temperatureHighest', checked: false, display: true },
      { label: '最低気温', value: 'temperatureLowest', checked: false, display: true },
      { label: '寒暖差', value: 'temperatureDifference', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      // 日射量
      { label: '日射量', value: 'solarRadation', checked: false, display: true },
      { label: '積算日射量', value: 'integratedInsolation', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      // 積算降水量
      { label: '積算降水量', value: 'soilStatus', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      { label: '', value: '', checked: false, display: true },
      // 水位等
      { label: '水位', value: 'waterLevel', checked: true, display: true },
      { label: '水温', value: 'waterTemp', checked: true, display: true },
      { label: '地温', value: 'groundTemp', checked: true, display: true },
      { label: 'pH', value: 'ph', checked: false, display: true }
    ]
  }

  /* 表示項目リセット */
  private resetGraphItem () {
    /* チェックボックス */
    this.checkboxes = this.getcheckboxes()
    this.displayCheckbox()

    /* 年 */
    this.selectedYear = this.$store.state.graphState.defaultGraphYear

    /* シーズン */
    this.selectedSeason = this.$store.state.graphState.defaultGraphSeason

    this.changeTab('1')

    this.selectedFieldName = ''
    this.showFieldChoice = false
    this.defaultDataChange = true
  }

  private removeSelected () {
    this.selectedFieldName = ''
    this.$store.commit('fieldChoiceState/setChoosingModalFieldId', null)
    this.showFieldChoice = false
  }

  /* モーダルを閉じる */
  private closeModal () {
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    // 閉じる前に項目リセット
    // 検索保持があればその状態に戻す
    if (settingData !== null) {
      this.checkboxes = settingData.checkboxs
      this.selectedYear = settingData.year
      this.selectedSeason = settingData.season
      this.selectedFieldName = settingData.field
      this.changeTab(settingData.tab)
      this.selectedPast = settingData.past
    } else {
      this.selectedYear = this.$store.state.graphState.defaultGraphYear
      this.selectedSeason = this.$store.state.graphState.defaultGraphSeason
    }

    this.$store.commit('setFlagState/setOpenSettingModalFlag', false)
    this.$emit('close-modal')
  }
}
